import { render, staticRenderFns } from "./VoucherAboutPopup.vue?vue&type=template&id=08e68409&scoped=true&"
import script from "./VoucherAboutPopup.vue?vue&type=script&lang=js&"
export * from "./VoucherAboutPopup.vue?vue&type=script&lang=js&"
import style0 from "./VoucherAboutPopup.vue?vue&type=style&index=0&id=08e68409&prod&lang=scss&scoped=true&"
import style1 from "./VoucherAboutPopup.vue?vue&type=style&index=1&id=08e68409&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e68409",
  null
  
)

export default component.exports